<template>
  <div class="menuContainer">
    <p class="title">存款产品</p>
    <el-menu
      :default-active="activeProduct"
      class="el-menu-demo"
      mode="vertical"
      text-color="#333"
    >
      <el-menu-item index="/manual/depositManual">
        <router-link to="/manual/depositManual">个人大额存单</router-link>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  computed: {
    activeProduct() {
      return this.$route.path
    },
  },
}
</script>

<style lang="scss" scoped>
.menuContainer [role='menubar'] {
  width: 320px;
}
.el-menu-item {
  a {
    color: inherit;
    text-decoration: none;
  }
}
</style>
